import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WeatherReadingCreatePage } from './weather-reading-create';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    WeatherReadingCreatePage,
  ],
  imports: [
    IonicPageModule.forChild(WeatherReadingCreatePage),
    TextMaskModule,
    SharedModule,
    DirectivesModule,
  ],
})
export class WeatherReadingCreatePageModule {
}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-reading-create/weather-reading-create.module.ts